import React from 'react';
import { Breadcrumbs, Link, Box } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'types/types';
//import { findItemByValueRecursively } from '../CommonService';

const BreadcrumbComponent = () => {
  const { activeView } = useSelector(
    (state: RootState) => state.applicationState
  );
  const navigate = useNavigate();
  const activeViewAppName =
    activeView?.properties?.find(
      (_) => _.Name === 'appTitle' || _.Name === 'selectedAppTitle'
    )?.Value || 'Applications';

  const activeViewAppValue = activeView?.properties?.find(
    (_) => _.Name === 'appValue' || _.Name === 'selectedApp'
  )?.Value;

  const activeViewName =
    activeView?.title || activeView?.text || activeView?.viewId || 'ViewName';

  const isLandingView = activeView?.viewId?.includes('landing');

  return (
    <Box className={'breadcrumbs-bar'}>
      <Breadcrumbs
        separator={<NavigateNext className={'breadcrumb-navigation-next'} />}
        aria-label="breadcrumb"
        classes={{ separator: 'separator', root: 'breadcrumb' }}
      >
        <Link
          color="inherit"
          onClick={() => navigate(`/view/landingPageView`)}
          className="text link"
        >
          Network Insight
        </Link>
        {activeViewAppName && (
          <Link
            color="inherit"
            onClick={() =>
              activeViewAppValue &&
              !isLandingView &&
              navigate(
                `/view/landingPageView?selectedApp=${activeViewAppValue}`
              )
            }
            className="text link"
          >
            {activeViewAppName}
          </Link>
        )}
      </Breadcrumbs> 
      <Box className={'active-view-title'}>{activeViewName}</Box>
    </Box>
  );
};

export default BreadcrumbComponent;
